interface AppConfig {
  apiUrl: string;
  appUrl: string;
  shopUrl: string;
  endActivateUrl: string;
  url: string; // Unity CDN URL
  adminApiKey: string;
  serverPort: number;
}

// Defaults из import.meta.env (fallback для build-time значений)
// Используется если API config недоступен или при первой загрузке
const defaultConfig: AppConfig = {
  apiUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  appUrl: import.meta.env.VITE_APP_URL || 'https://play.gameinvitation.com',
  shopUrl: import.meta.env.VITE_SHOP_URL || 'https://gameinvitation.com',
  endActivateUrl: import.meta.env.VITE_END_ACTIVATE_URL || 'https://gameinvitation.com',
  url: import.meta.env.VITE_URL || '',
  adminApiKey: '',
  serverPort: Number(import.meta.env.VITE_SERVER_PORT) || 3003
};

// Runtime config (loaded from server)
let config: AppConfig = defaultConfig;
let isInitialized = false;
let initPromise: Promise<void> | null = null;

/**
 * Initialize config from server API
 * Called once at app startup
 */
export async function initConfig(): Promise<void> {
  // Prevent multiple init calls
  if (initPromise) {
    return initPromise;
  }

  initPromise = (async () => {
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      let res: Response;
      try { res = await fetch('/api/config', { signal: controller.signal }); } finally { clearTimeout(timeout); }
      if (res.ok) {
        const serverConfig = await res.json();
        // Merge with defaults (server config takes precedence)
        Object.assign(config, {
          ...defaultConfig,
          ...serverConfig,
          serverPort: Number(serverConfig.serverPort) || defaultConfig.serverPort,
          adminApiKey: '',
        });
        isInitialized = true;
      }
    } catch (e) {
      // Fallback на defaults - это нормально
      // Server может быть недоступен при первой загрузке
      console.warn('Config API unavailable, using defaults');
    }
  })();

  return initPromise;
}

/**
 * Get current config
 * Returns defaults if not initialized
 */
export function getConfig(): AppConfig {
  return config;
}

/**
 * Check if config was loaded from server
 */
export function isConfigInitialized(): boolean {
  return isInitialized;
}

// Legacy export for backward compatibility
export default config;
